import { computed } from 'vue';
import store from '@/store';

export default class CountryListComponent {
	public visibleCountries = computed((): string[] => {
		return store.getters.visibleCountries();
	});
}
